import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'task-card',
  templateUrl: './task-card.component.html',
  styleUrls: ['./task-card.component.scss'],
})
export class TaskCardComponent implements OnInit {
  @Input() clickable: boolean = false;

  get required() {
    return this.task.requerido;
  }
  @Input() task: any;

  constructor() {}

  ngOnInit() {}
}
